import React, { useEffect, useState } from 'react'
import { Info, X } from 'react-feather'
import styled, { keyframes } from 'styled-components'

const pulseGlow = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.3); }
  70% { box-shadow: 0 0 0 6px rgba(59, 130, 246, 0); }
  100% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0); }
`

const slideDown = keyframes`
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
`

const FixedBannerWrapper = styled.div`
  position: fixed;
  top: 72px; /* Adjust based on your header height */
  left: 0;
  right: 0;
  z-index: 2;
  animation: ${slideDown} 0.4s cubic-bezier(0.16, 1, 0.3, 1);
`

const BannerWrapper = styled.div`
  background: linear-gradient(90deg, #121626, #151b30);
  border-bottom: 1px solid rgba(59, 130, 246, 0.2);
  height: 64px;
  display: flex;
  align-items: center;
  width: 100%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;

  /* Blue accent line */
  &::before {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      rgba(59, 130, 246, 0) 0%,
      rgba(59, 130, 246, 0.8) 50%,
      rgba(59, 130, 246, 0) 100%
    );
  }

  @media (max-width: 600px) {
    height: auto;
    min-height: 64px;
    padding: 12px 0;
  }
`

const BannerContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
  padding: 0 24px;
  position: relative;
  justify-content: center; /* Center the content */
`

const InfoTextGroup = styled.div`
  display: flex;
  align-items: center;
  max-width: 800px; /* Control maximum width */
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #3b82f6;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  color: white;
  flex-shrink: 0;
  animation: ${pulseGlow} 2s infinite;
  margin-right: 16px;

  @media (max-width: 600px) {
    margin-right: 12px;
  }
`

const TextContent = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #e2e8f0;
  text-align: left;
  flex: 0 1 auto;

  @media (max-width: 600px) {
    font-size: 13px;
  }
`

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 50%;
  flex-shrink: 0;

  /* Default (mobile): relative positioning */
  position: relative;
  margin-left: 4px;

  /* Larger screens: absolute positioning */
  @media (min-width: 768px) {
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    margin-left: 0;
  }

  &:hover {
    color: #e2e8f0;
    background-color: rgba(255, 255, 255, 0.05);
  }
`

const RewardText = styled.span`
  color: #3b82f6;
  font-weight: 600;
`

export default function MigrationBanner({ rewardVaultRewardTokenSymbol }: { rewardVaultRewardTokenSymbol?: string }) {
  const [isVisible, setIsVisible] = useState(true)
  const rewardLabel = rewardVaultRewardTokenSymbol || 'rewards'

  useEffect(() => {
    if (isVisible) {
      document.body.style.paddingTop = '64px'
    } else {
      document.body.style.paddingTop = '0'
    }

    return () => {
      document.body.style.paddingTop = '0'
    }
  }, [isVisible])

  if (!isVisible) {
    return null
  }

  return (
    <FixedBannerWrapper>
      <BannerWrapper>
        <BannerContent>
          <InfoTextGroup>
            <IconWrapper>
              <Info size={16} />
            </IconWrapper>
            <TextContent>
              This island is eligible for <RewardText>{rewardLabel}</RewardText> now! You have staked in the Kodiak
              Farm, please migrate to the{' '}
              {rewardVaultRewardTokenSymbol ? (
                <>
                  <RewardText>{rewardVaultRewardTokenSymbol}</RewardText>-earning Reward Vault
                </>
              ) : (
                'Reward Vault'
              )}
            </TextContent>
          </InfoTextGroup>
          <CloseButton onClick={() => setIsVisible(false)}>
            <X size={16} />
          </CloseButton>
        </BannerContent>
      </BannerWrapper>
    </FixedBannerWrapper>
  )
}
